export default __webpack_public_path__ + "static/media/2.1cee4706.jpg";